import { useEffect } from 'react'

import { siteTitle } from '@/constants'

import { NotificationsCard } from '../notifications/NotificationsCard'
import { UserSearch } from '../users/UserSearch'
import { SystemStats } from './SystemStats'

export const AdminHomePage = () => {
  useEffect(() => {
    document.title = `Admin Portal - ${siteTitle}`
  }, [])

  return (
    <main role="main" className="container mx-auto py-4 flex flex-col gap-4">
      <NotificationsCard />
      <SystemStats />
      <UserSearch />
    </main>
  )
}
